<template>
  <div class="seomain">
    <div class="tab-content">
      <div class="st-list-box pan-106">
        <div class="st-list" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top">
            <div class="t-tit">{{ v.code }}</div>
            <div class="t-status red" v-if="v.qualityname == '未质检'">
              {{ v.qualityname }}
            </div>
            <div class="t-status" v-else>{{ v.qualityname }}</div>
          </div>
          <div class="st-list-main">
            <p>SKU：{{ v.sku }}</p>
            <p>品 类：{{ v.cname }}</p>
            <p>品 牌：{{ v.brand }}</p>
            <p>型 号：{{ v.model }}</p>
            <p>配 置：{{ v.deploy }}</p>
            <p>供应商：{{ v.supplier_name }}</p>
            <p>联系人：{{ v.supplier_contactone }}</p>
            <p>
              联系电话：<a :href="'tel:' + v.supplier_contactonenumber">
                {{ v.supplier_contactonenumber }}</a
              >
            </p>
            <p>联系地址：{{ v.supplier_adderss }}</p>
            <p>采购价：{{ v.purchase_money }}</p>
            <p>上次采购价：{{ v.last_purchase_money }}</p>
            <p>预计交期：{{ v.deliverytime }}</p>
            <p>采购数量：{{ v.purchase_num }}</p>
            <p>已入库：{{ v.storageed }}</p>
            <p class="red bold">待入库：{{ v.storageing }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      stlist: [],
      stinfo: {},
      oneinfo: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    async init() {
      let id = this.$route.params.id;
      let result = await this.$post(this.$api.stGetCaigoudanInfo, {
        id,
      });
      this.stlist = result.data;
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function () {
      window.h5sdk.biz.navigation.setTitle({ title: "采购订单详情" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.input-item {
  display: flex;
}
.input-item span {
  display: inline-block;
}
.input-item .input {
  flex: 1;
}
// .mix-detail-box input {
//     margin-top: 0 !important;
// }
</style>